import React from 'react';

import './index.css';

const Component = (props) => {
    const { items } = props;

    return (
        <div>
            <h5>Member of Professional Bodies:</h5>
            <p>
                {items.map((item, index) => {
                    return (
                        <span key={index}>
                            {(() => {
                                if (index !== 0) return <span>&bull;&nbsp;&nbsp;</span>;
                                return '';
                            })()}
                            {item
                                .replace(/-/g, '\u{2011}')
                                .replace(/ /g, '\u00a0')
                                .replace(/\//g, '\u{2044}')}
                            &nbsp;&nbsp;
                        </span>
                    );
                })}
            </p>
        </div>
    );
};

export default Component;
